import { gql } from 'apollo-angular'

import { ARTICLE_WITH_AUTHORS_FIELDS } from '../../fragments/article-fragments'
import { CATEGORY_BASIC_FIELDS } from '../../fragments/category.fragment'
import { EDITION_LINK_FIELDS } from '../../fragments/edition.fragment'
import { MAGAZINE_BASIC_FIELDS } from '../../fragments/magazine.fragments'

export const GET_ARTICLES_BY_AUTHOR_ID = gql`
  query getArticlesByAuthorId($authorId: JSON, $page: Int, $limit: Int) {
    Articles(
      select: true
      where: {
        AND: [
          { users__authors: { in: [$authorId] } }
          { published_at: { not_equals: null } }
        ]
      }
      page: $page
      limit: $limit
      sort: "-published_at"
    ) {
      docs {
        ...ArticleWithAuthorsFields
        content_preview
        edition {
          ...EditionLinkFields
        }
        magazine {
          ...MagazineBasicFields
          manual_title
          manual_description
          manual_url
        }
        categories {
          ...CategoryBasicFields
        }
      }
      totalDocs
      page
      totalPages
    }
  }
  ${EDITION_LINK_FIELDS}
  ${MAGAZINE_BASIC_FIELDS}
  ${ARTICLE_WITH_AUTHORS_FIELDS}
  ${CATEGORY_BASIC_FIELDS}
`
